module.exports = __webpack_public_path__ + "img/power-bi.5bd74562.svg";